"use client";

import dynamic from "next/dynamic";

import { Container } from "@/components/layout/container";

const PromoSlider = dynamic(() =>
  import("./promo-slider").then((mod) => mod.PromoSlider),
);

const PopularDestination = dynamic(() =>
  import("./popular-destination").then((mod) => mod.PopularDestination),
);

const TopDestination = dynamic(() =>
  import("./top-destination").then((mod) => mod.TopDestination),
);

export function DeferredHomeSections() {
  return (
    <div className="space-y-12 ">
      <Container>
        <PromoSlider />
      </Container>
      <Container className="pt-10">
        <PopularDestination />
      </Container>
      <div>
        <TopDestination />
      </div>
    </div>
  );
}
